module.exports = __webpack_public_path__ + "static/media/Logo_Ivry.e62643b3.jpg";